import { apiCreate, apiUpdate } from './ApiBaseActions';
export const API_CREATE_PROFFIT_SEARCH_PPTX = 'API_CREATE_PROFFIT_SEARCH_PPTX';
export const API_UPDATE_PROFFIT_SEARCH_PAGE_TYPES = 'API_UPDATE_PROFFIT_SEARCH_PAGE_TYPES';
/**
 * パワーポイントのダウンロードの実行
 * @param data
 * @param meta
 * @returns {{payload: {data: *}, meta: *&{cancelPrevious: boolean, apiPath: *, fetch: string, type: string}, type: string}}
 */
export const apiCreateProffitSearchPptx = (data, meta) => apiCreate(API_CREATE_PROFFIT_SEARCH_PPTX, '/proffit_search/slide/pptx', data, Object.assign({ isBlob: true }, meta));
/**
 * ページのタグの更新
 * @param id
 * @param data
 * @param meta
 * @returns {{payload: {data: *}, meta: *&{cancelPrevious: boolean, apiPath: *, fetch: string, type: string}, type: string}}
 */
export const apiUpdateProffitSearchPageTypes = (id, data, meta) => apiUpdate(API_UPDATE_PROFFIT_SEARCH_PAGE_TYPES, `/proffit_search/slide/page/${id}/page_type`, data, Object.assign({}, meta));
